var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTimer(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "timer-ai"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12 21C13.9891 21 15.8968 20.2098 17.3033 18.8033C18.7098 17.3968 19.5 15.4891 19.5 13.5C19.5 11.5109 18.7098 9.60322 17.3033 8.1967C15.8968 6.79018 13.9891 6 12 6C10.0109 6 8.10322 6.79018 6.6967 8.1967C5.29018 9.60322 4.5 11.5109 4.5 13.5C4.5 15.4891 5.29018 17.3968 6.6967 18.8033C8.10322 20.2098 10.0109 21 12 21ZM12 22.5C9.61305 22.5 7.32387 21.5518 5.63604 19.864C3.94821 18.1761 3 15.8869 3 13.5C3 11.1131 3.94821 8.82387 5.63604 7.13604C7.32387 5.44821 9.61305 4.5 12 4.5C14.3869 4.5 16.6761 5.44821 18.364 7.13604C20.0518 8.82387 21 11.1131 21 13.5C21 15.8869 20.0518 18.1761 18.364 19.864C16.6761 21.5518 14.3869 22.5 12 22.5Z",
    fill: "#7E7F83"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M12 7.5C12.1989 7.5 12.3897 7.57902 12.5303 7.71967C12.671 7.86032 12.75 8.05109 12.75 8.25L12.738 13.5C12.738 13.6989 12.659 13.8897 12.5183 14.0303C12.3777 14.171 12.1869 14.25 11.988 14.25C11.7891 14.25 11.5983 14.171 11.4577 14.0303C11.317 13.8897 11.238 13.6989 11.238 13.5L11.25 8.25C11.25 8.05109 11.329 7.86032 11.4697 7.71967C11.6103 7.57902 11.8011 7.5 12 7.5Z",
    fill: "#7E7F83"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M10.5 13.5C10.5 13.8978 10.658 14.2794 10.9393 14.5607C11.2206 14.842 11.6022 15 12 15C12.3978 15 12.7794 14.842 13.0607 14.5607C13.342 14.2794 13.5 13.8978 13.5 13.5C13.5 13.1022 13.342 12.7206 13.0607 12.4393C12.7794 12.158 12.3978 12 12 12C11.6022 12 11.2206 12.158 10.9393 12.4393C10.658 12.7206 10.5 13.1022 10.5 13.5ZM12.75 3V6H11.25V3H9C8.80109 3 8.61032 2.92098 8.46967 2.78033C8.32902 2.63968 8.25 2.44891 8.25 2.25C8.25 2.05109 8.32902 1.86032 8.46967 1.71967C8.61032 1.57902 8.80109 1.5 9 1.5H15C15.1989 1.5 15.3897 1.57902 15.5303 1.71967C15.671 1.86032 15.75 2.05109 15.75 2.25C15.75 2.44891 15.671 2.63968 15.5303 2.78033C15.3897 2.92098 15.1989 3 15 3H12.75Z",
    fill: "#7E7F83"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimer);
export default __webpack_public_path__ + "static/media/timer.210aea602cc5d676dcf42ab0853d95e6.svg";
export { ForwardRef as ReactComponent };